import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useState } from "react";
import textWeight from "../../utils/textWeight";
import { useUpdateMutation, useUser } from "../../actions/authActions";
export default () => {
  const navigate = useNavigate();
  const { TextWeight } = textWeight();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const userId = localStorage.getItem("userId");
  const dispatch = useDispatch();
  const { data: userprofile, isError, error } = useUser(userId);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      current_password: "",
      password: "",
      confirm_password: "",
    },
  });

  const mutation = useUpdateMutation(
    userId,
    dispatch,
    setLoadingToapi,
    navigate
  );
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading userprofile: {error.message}
        </p>
      </div>
    );
  }
  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);
    const playloadData = new FormData();
    playloadData.append("email", userprofile?.email);
    playloadData.append("first_name", userprofile?.first_name);
    playloadData.append("last_name", userprofile?.last_name);
    playloadData.append("mobile_num", userprofile?.mobile_num);
    playloadData.append("current_password", data.current_password);
    playloadData.append("password", data.password);
    playloadData.append("_method", "PUT");
    mutation.mutate(playloadData);
  };
  return {
    handleSubmit,
    onSubmit,
    control,
    errors,
    register,
    setValue,
    getValues,
    loadingToapi,
    TextWeight,
  };
};
